<template>
  <div class="part-inventory-stock">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addEvent" v-if="funcView.parts_inventory_add">{{ funcView.parts_inventory_add }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addBatchPart" v-if="funcView.parts_inventory_batch">
            <i class="icon icon-piliangtianjia"></i>
            {{ $t('dms_part_inventory_stock.pi_liang_ru_ku') }}
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- <el-form-item style="float: right;">
          <el-button class="table-set" style="vertical-align: top;" @click="exportTable('partExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item> -->
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('dms_part_inventory_stock.ljbhljSNljmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_part_inventory_stock.zhi_bao_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.warrantyDate" type="daterange" :picker-options="pickerOption"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_stock.ru_ku_dan_hao')">
          <el-input v-model="formSearch.inBatchNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_stock.ru_ku_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.dataTimes" type="daterange" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_stock.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_stock.ji_shen_hao')">
          <el-input v-model="formSearch.bodyNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_stock.ling_jian_wei_zhi')">
          <el-input v-model="formSearch.componentCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_stock.cai_gou_dan_hao')">
          <el-input v-model="formSearch.poNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_part_inventory_stock.lai_liao_dan_hao')">
          <el-input v-model="formSearch.incomingNum"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table index :column="tableColumn" :data="tableList" @filter="filterChange" @sort="sortChange" height="100%" :slots="['action']" v-model="tableSelect">
        <!-- <template v-slot:partCode="scope" >
          <div class="cell-link" @click="watchEvent(scope.row)">{{ scope.row.partCode }}</div>
        </template> -->
        <template v-slot:action="scope">
          <!-- 新零件才显示：新增，编辑 -->
          <span v-if="`${scope.row.partState}` === '1'">
            <el-button type="text" size="mini" @click="editEvent(scope.row)" v-if="funcView.parts_inventory_edit">{{ funcView.parts_inventory_edit }}</el-button>
            <el-button type="text" size="mini" @click="deleteEvent(scope.row)" v-if="funcView.parts_inventory_delete">{{ funcView.parts_inventory_delete }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <part-inventory-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></part-inventory-dialog>
    <part-inventoryEdit-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onPageChange({ page: 1 })"></part-inventoryEdit-dialog>
    <part-inventory-batch-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="onPageChange({ page: 1 })"></part-inventory-batch-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import partInventoryDialog from './part_inventory_dialog.vue';
import partInventoryEditDialog from './part_inventoryEdit_dialog.vue';
import partInventoryBatchDialog from './part_inventory_batch_dialog.vue';

export default {
  name: '',
  mixins: [resetFormSearchMixins],
  components: { partInventoryDialog, partInventoryEditDialog, partInventoryBatchDialog },
  props: {},
  data() {
    return {
      tableCode: 'part_inventory',
      formSearch: {
        search: '',
        partType: '',
        replaceMethod: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        dataTimes: [],
        componentCode: '',
        bodyNum: '',
        country: '',
        websiteName: '',
        inBatchNum: '',
        warrantyDate: [],
        stockState: 2,
        // 采购单号
        poNum: '',
        // 来料单号
        incomingNum: '',
      },

      tableSelect: [],
      tableList: [],
      totalRows: null,
      // 新增
      dialogVisible: false,
      dialogModel: {},
      // 编辑
      dialogVisible1: false,
      dialogModel1: {},
      // 入库
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 新增
    addEvent: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('dms_part_inventory_stock.tian_jia_ling_jian');
      this.dialogVisible = true;
    },
    // 编辑
    editEvent: function (data) {
      this.dialogModel1.type = 'edit';
      this.dialogModel1.title = this.$t('dms_part_inventory_stock.bian_ji_ling_jian');
      this.dialogModel1.data = data;
      this.dialogVisible1 = true;
    },

    addBatchPart: function () {
      this.dialogVisible2 = true;
    },
    // 删除
    deleteEvent: function (data) {
      this.$showConfirm(this.$t('dms_part_inventory_stock.nqrscljSNwodljm', [data.partSn]))
        .then(() => {
          this.$postJSON(`${apis.partStockDelete}/${data.stockFactoryId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.inTimeStart = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.inTimeEnd = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.formSearch.warrantyDateStart = this.formSearch.warrantyDate ? this.formSearch.warrantyDate[0] : '';
      this.formSearch.warrantyDateEnd = this.formSearch.warrantyDate ? this.formSearch.warrantyDate[1] : '';
      this.$getJSON(apis.partStockPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
  created() {},
  mounted() {
    this.getTableList();
    this.getTableColumn();
    this.getFuncView();
  },
};
</script>

<style lang="scss">
.part-inventory-stock {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  overflow: hidden;
}
</style>
